import React from "react";
import CustomDiv from "../../Shared/CustomDiv";
import Text from "../../Shared/Text";
import {useQuery} from "react-query";
import {myCouponFn} from "../../Services/Coupon";
import {
  Collapse,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const Coupon = () => {
  const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked((prev) => !prev);
  };
  const {data} = useQuery(["Coupon"], () => myCouponFn());
  const coupon = data?.data?.data;
  //   const accountHistory = data?.data?.data?.wallet_history;
  console.log("coupon", coupon);
  return (
    <CustomDiv className="flex flex-col gap-4  px-[8%] py-[1%]">
      <p className="font-bold text-xl">My Coupons</p>
      {coupon?.map((item) => {
        return (
          <div className="flex flex-col w-full my-5 border-b ">
            <div className="flex flex-row justify-between items-center">
              <p className="text-xl font-bold text-green-400">
                {item?.offer_tag}
              </p>
              <p className="text-xl font-bold text-black hover:text-pink-500">
                {item?.coupon_code}
              </p>
            </div>

            <div className="flex flex-col my-3 ">
              <div className="flex justify-between lg:border-b border-b-2">
                <p>Purchase upto :</p>
                <p className="font-bold text-pink-500 pl-2">
                  ₹{item?.purchase_upto}
                </p>
              </div>
              <div className="flex justify-between lg:border-b border-b-2 ">
                <p>Discount :</p>
                <p className="font-bold text-pink-500 pl-2">
                  ₹{item?.discount}
                </p>
              </div>
            </div>
            <p
              onClick={handleChange}
              className="text-sm text-red-400 hover:text-red-600 cursor-pointer"
            >
              Terms and Conditions
            </p>
            <Collapse in={checked}>{item?.term_condition}</Collapse>
          </div>
        );
      })}
    </CustomDiv>
  );
};

export default Coupon;
